"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNftSaleConfigsResponseAllOfToJSON = exports.GetNftSaleConfigsResponseAllOfFromJSONTyped = exports.GetNftSaleConfigsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetNftSaleConfigsResponseAllOfFromJSON(json) {
    return GetNftSaleConfigsResponseAllOfFromJSONTyped(json, false);
}
exports.GetNftSaleConfigsResponseAllOfFromJSON = GetNftSaleConfigsResponseAllOfFromJSON;
function GetNftSaleConfigsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nftSaleConfigs': (json['nftSaleConfigs'].map(_1.NftSaleConfigFromJSON)),
    };
}
exports.GetNftSaleConfigsResponseAllOfFromJSONTyped = GetNftSaleConfigsResponseAllOfFromJSONTyped;
function GetNftSaleConfigsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nftSaleConfigs': (value.nftSaleConfigs.map(_1.NftSaleConfigToJSON)),
    };
}
exports.GetNftSaleConfigsResponseAllOfToJSON = GetNftSaleConfigsResponseAllOfToJSON;
